// NPM Imports
import React from "react";
import Modal from "react-responsive-modal";
import { Button } from "@revvsales/components";

// Components Imports

// Internal Imports
import SHIELD from "../../../../assets/ic-shield.svg";
import logoAWS from "../../../../assets/certificate-logos/logo-aws.png";
import logoOneSpan from "../../../../assets/certificate-logos/logo-onespan.png";
import logoChargebee from "../../../../assets/certificate-logos/logo-chargebee.svg";

import logoCSA from "../../../../assets/certificate-logos/logo-csa.jpg";
import logoSOC from "../../../../assets/certificate-logos/logo-SOC.jpg";
import logoISO from "../../../../assets/certificate-logos/logo-iso27001.jpg";
import logoESIGN from "../../../../assets/certificate-logos/logo-esign.png";
import logoUETA from "../../../../assets/certificate-logos/logo-UETA.png";
import logoEIDAS from "../../../../assets/certificate-logos/logo-eiDAS.png";
import logoPCI from "../../../../assets/certificate-logos/logo-PCI.jpg";

const NavbarShieldHelpPopup = props => {
  const _closePopup = () => {
    props.closePopup("showShieldHelpPopup", false);
  };

  return (
    <Modal open onClose={_closePopup} center>
      <div
        className="modal-container"
        data-test="navbarshieldhelppopup-container">
        <div
          className="modal-heading"
          data-test="navbarshieldhelppopup-modal-heading">
          <span className="navbarshieldhelppopup-header-icon">
            <img
              src={SHIELD}
              data-test="revvsales-trust-center"
              className="revvsales-tc-img"
              alt="Revv Trust Center"
            />
          </span>
          <div className="navbarshieldhelppopup-header-text">
            <span className="navbarshieldhelppopup-header-title">
              Revv Trust Center
            </span>
            <span className="navbarshieldhelppopup-header-subtitle">
              Our cloud platform service provider certificates.
            </span>
          </div>
        </div>

        <div className="navbarshieldhelppopup-modal-body">
          <div
            className="navbarshieldhelppopup-modal-subheading"
            data-test="navbarshieldhelppopup-modal-subheading">
            Global Cloud certification
          </div>
          <div className="navbarshieldhelppopup-row">
            <div className="navbarshieldhelppopup-col">
              <div className="navbarshieldhelppopup-certificate-parent">
                <span className="navbarshieldhelppopup-img-wrapper">
                  <img
                    src={logoAWS}
                    className="navbarshieldhelppopup-img"
                    alt="AWS"
                  />
                </span>
                <span className="navbarshieldhelppopup-text-wrapper">
                  Powered by AWS
                </span>
              </div>
            </div>
            <div className="navbarshieldhelppopup-col-child">
              <div className="navbarshieldhelppopup-certificate-list ">
                <div className="navbarshieldhelppopup-certificate-child">
                  <span className="navbarshieldhelppopup-img-wrapper">
                    <img
                      src={logoCSA}
                      className="navbarshieldhelppopup-img"
                      alt="CSA"
                    />
                  </span>
                  <span className="navbarshieldhelppopup-text-wrapper">
                    <span className="navbarshieldhelppopup-text-name">CSA</span>
                    Cloud Security Alliance Controls
                  </span>
                </div>
                <div className="navbarshieldhelppopup-certificate-child">
                  <span className="navbarshieldhelppopup-img-wrapper">
                    <img
                      src={logoSOC}
                      className="navbarshieldhelppopup-img"
                      alt="SOC"
                    />
                  </span>
                  <span className="navbarshieldhelppopup-text-wrapper">
                    <span className="navbarshieldhelppopup-text-name">
                      SOC 1
                    </span>
                    Audit Controls Report
                  </span>
                </div>
                <div className="navbarshieldhelppopup-certificate-child">
                  <span className="navbarshieldhelppopup-img-wrapper">
                    <img
                      src={logoSOC}
                      className="navbarshieldhelppopup-img"
                      alt="SOC"
                    />
                  </span>
                  <span className="navbarshieldhelppopup-text-wrapper">
                    <span className="navbarshieldhelppopup-text-name">
                      SOC 2
                    </span>
                    Security, Availability, & Confidentiality Report
                  </span>
                </div>
                <div className="navbarshieldhelppopup-certificate-child">
                  <span className="navbarshieldhelppopup-img-wrapper">
                    <img
                      src={logoISO}
                      className="navbarshieldhelppopup-img"
                      alt="ISO 27001"
                    />
                  </span>
                  <span className="navbarshieldhelppopup-text-wrapper">
                    <span className="navbarshieldhelppopup-text-name">
                      ISO 27001
                    </span>
                    Security Management Controls
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div
            className="navbarshieldhelppopup-modal-subheading"
            data-test="navbarshieldhelppopup-modal-subheading">
            eSignature certification
          </div>
          <div className="navbarshieldhelppopup-row">
            <div className="navbarshieldhelppopup-col">
              <div className="navbarshieldhelppopup-certificate-parent">
                <span className="navbarshieldhelppopup-img-wrapper">
                  <img
                    src={logoOneSpan}
                    className="navbarshieldhelppopup-img"
                    alt="Onespan"
                  />
                </span>
                <span className="navbarshieldhelppopup-text-wrapper">
                  Powered by OneSpan
                </span>
              </div>
            </div>
            <div className="navbarshieldhelppopup-col-child">
              <div className="navbarshieldhelppopup-certificate-list ">
                <div className="navbarshieldhelppopup-certificate-child">
                  <span className="navbarshieldhelppopup-img-wrapper">
                    <img
                      src={logoESIGN}
                      className="navbarshieldhelppopup-img"
                      alt="ESIGN"
                    />
                  </span>
                  <span className="navbarshieldhelppopup-text-wrapper">
                    <span className="navbarshieldhelppopup-text-name">
                      ESIGN Act
                    </span>
                    Electronic Signatures in Global and National Commerce Act
                  </span>
                </div>
                <div className="navbarshieldhelppopup-certificate-child">
                  <span className="navbarshieldhelppopup-img-wrapper">
                    <img
                      src={logoUETA}
                      className="navbarshieldhelppopup-img"
                      alt="UETA"
                    />
                  </span>
                  <span className="navbarshieldhelppopup-text-wrapper">
                    <span className="navbarshieldhelppopup-text-name">
                      UETA Act
                    </span>
                    Uniform Electronic Transactions Act
                  </span>
                </div>
                <div className="navbarshieldhelppopup-certificate-child">
                  <span className="navbarshieldhelppopup-img-wrapper">
                    <img
                      src={logoEIDAS}
                      className="navbarshieldhelppopup-img"
                      alt="eIDAS"
                    />
                  </span>
                  <span className="navbarshieldhelppopup-text-wrapper">
                    <span className="navbarshieldhelppopup-text-name">
                      eIDAS
                    </span>
                    Electronic Identification and Trusted Services Regulation
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div
            className="navbarshieldhelppopup-modal-subheading"
            data-test="navbarshieldhelppopup-modal-subheading">
            Payment gateway certification
          </div>
          <div className="navbarshieldhelppopup-row">
            <div className="navbarshieldhelppopup-col">
              <div className="navbarshieldhelppopup-certificate-parent">
                <span className="navbarshieldhelppopup-img-wrapper">
                  <img
                    src={logoChargebee}
                    className="navbarshieldhelppopup-img"
                    alt="Chargebee"
                  />
                </span>
                <span className="navbarshieldhelppopup-text-wrapper">
                  Powered by Chargebee
                </span>
              </div>
            </div>
            <div className="navbarshieldhelppopup-col-child">
              <div className="navbarshieldhelppopup-certificate-list ">
                <div className="navbarshieldhelppopup-certificate-child">
                  <span className="navbarshieldhelppopup-img-wrapper">
                    <img
                      src={logoPCI}
                      className="navbarshieldhelppopup-img"
                      alt="PCI"
                    />
                  </span>
                  <span className="navbarshieldhelppopup-text-wrapper">
                    <span className="navbarshieldhelppopup-text-name">
                      PCI DSS Level 1
                    </span>
                    Payment Card Standards
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="modal-footer">
          <Button
            className="btn btn-primary modal-footer-btn submit-btn"
            data-test="navbarshieldhelppopup-submit-btn"
            onClick={_closePopup}>
            Done
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default NavbarShieldHelpPopup;



// WEBPACK FOOTER //
// ./src/components/NavBarWrapper/NavBar/NavbarShieldHelpPopup/index.js